import constants from 'constants';

const {
  SET_QUIZ_STATUS,
} = constants;

const quiz = (quiz = {
  status: '',
  result: 0
}, action) => {
  switch(action.type) {
    case SET_QUIZ_STATUS:
      return {
        ...quiz,
        status: action.status,
        result: action.result
      }
    default:
      return quiz;
  }
}

export { quiz };



// WEBPACK FOOTER //
// ./src/reducers/quiz.js